const productvariety = {
    add: 'productvariety/add',
    bulkadd: 'productvariety/bulk-add',
    update: 'productvariety/update',
    remove: 'productvariety/remove',
    get: 'productvariety/get',
    getall: 'productvariety/getall',
    getlist: 'productvariety/getlist',
    setdefault: 'productvariety/set-default',
}
export default productvariety
